import React from 'react';
import _ from 'lodash';
import { Label, formatMessage, Store, showDrawer, setScreenData, Flexbox } from 'cw-ui-core';
import DotLabel from 'src/components/DotLabel';
import Locale from 'src/i18n';
import css from './NewUsers.scss';
import { EDIT_USER_DRAWER } from 'src/features/users/constants/drawerConstants';
import calculateStatus from 'src/features/users/utils/UserStatusUtils';
import cx from 'classnames';
import Tooltip from 'src/components/Tooltip/Tooltip';
import UserRolesColumn from 'src/features/users/components/Users/UserRolesColumn';

const onRowClick = user => {
    Store().dispatch(setScreenData('activeUserId', user.id));
    const loginScheme = user.loginScheme || 'Local Login';

    Store().dispatch(
        showDrawer(EDIT_USER_DRAWER, {
            activeLoginScheme: loginScheme,
        })
    );
};

const newDesktop = [
    {
        id: 'userName',
        accessor: 'firstName',
        Header: <Label className={css.nameHeader} value={formatMessage(Locale.name)} />,
        Cell: ({ row: { original: user } }) => {
            const firstName = user.firstName ? user.firstName : '';
            const lastName = user.lastName ? user.lastName : '';
            const [, statusColor] = calculateStatus(user.status);
            const toolTipContent = <span>{`${firstName} ${lastName}`}</span>;
            return (
                <Flexbox className={css.userNameContainer} onClick={() => onRowClick(user)}>
                    <div className={css.profileImage} style={{ background: statusColor }}>{`${
                        firstName.charAt(0) + lastName.charAt(0)
                    }`}</div>
                    <Tooltip toolTipContent={toolTipContent} className={css.toolTipNameContainer}>
                        <Label automationName="editUser" value={`${firstName} ${lastName}`} className={css.nameCell} />
                    </Tooltip>
                </Flexbox>
            );
        },
        headerClassName: cx(css.flex, css.noPointer, css.nameColumn),
        className: cx(css.flex, css.nameColumn),
    },
    {
        id: 'userEmail',
        accessor: 'email',
        Header: <Label className={css.header} value={formatMessage(Locale.email)} />,
        Cell: ({ row: { original: user } }) => {
            const toolTipContent = <span>{user.email}</span>;
            return (
                <Flexbox className={css.userEmailContainer} onClick={() => onRowClick(user)}>
                    <Tooltip toolTipContent={toolTipContent} className={css.toolTipContainer}>
                        <Label automationName="editUser" value={user.email} />
                    </Tooltip>
                </Flexbox>
            );
        },
        headerClassName: cx(css.flex, css.noPointer, css.emailColumn),
        className: cx(css.flex, css.emailColumn),
    },
    {
        id: 'userId',
        accessor: 'id',
        Header: <Label className={css.header} value={formatMessage(Locale.userId)} />,
        Cell: ({ row: { original: user } }) => {
            const toolTipContent = <span>{user.id}</span>;
            return (
                <Flexbox className={css.userIdContainer} onClick={() => onRowClick(user)}>
                    <Tooltip toolTipContent={toolTipContent} className={css.toolTipContainer}>
                        <Label automationName="editUser" value={user.id} />
                    </Tooltip>
                </Flexbox>
            );
        },
        headerClassName: cx(css.flex, css.noPointer, css.idColumn),
        className: cx(css.flex, css.idColumn),
    },
    {
        id: 'userStatus',
        accessor: 'isPending',
        Header: <Label className={css.header} value={formatMessage(Locale.userStatus)} />,
        Cell: ({ row: { original } }) => {
            const { status } = original;
            const [statusValue, statusColor] = calculateStatus(status);
            return (
                <DotLabel
                    automationName="editUser"
                    value={statusValue}
                    colorForStatus={statusColor}
                    hasIcon={false}
                    onClick={() => onRowClick(original)}
                />
            );
        },
        headerClassName: cx(css.flex, css.noPointer, css.statusColumn),
        className: cx(css.flex, css.statusColumn),
    },
    {
        id: 'userRoles',
        accessor: 'userRoles',
        Header: <Label className={css.header} value={formatMessage(Locale.identityRole)} />,
        Cell: ({ row: { original } }) => {
            return <UserRolesColumn original={original} onRowClick={onRowClick} />;
        },
        headerClassName: cx(css.flex, css.noPointer, css.userRolesColumn),
        className: cx(css.flex, css.userRolesColumn),
    },
    {
        id: 'connectedApps',
        accessor: 'connectedApps',
        Header: <Label className={css.header} value={formatMessage(Locale.noOfConnectedApps)} />,
        Cell: ({ row: { original: user } }) => {
            return (
                <Label
                    onClick={() => {
                        onRowClick(user);
                    }}
                    className={cx(css.flexCenter, css.noOfConnectedApps)}
                    value={_.size(user.connectedApps)}
                />
            );
        },
        headerClassName: cx(css.flexCenter, css.noPointer, css.connectedAppsColumn),
        className: cx(css.flexCenter, css.connectedAppsColumn),
    },
];

export default newDesktop;
